import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { Button, ChevronDown, DotsGrid, DotsVertical, Menu, Trash01 } from '@opendate-app/setlist';

const draggablePropsWithStyle = (provided, snapshot) => {
  var props =  {...provided.draggableProps};
  var style = Object.assign({}, props.style, {
    "display": (snapshot.isDragging ? "table" : "")
  });

  return Object.assign({}, props, {style: style});
}

const PerformerCard = ({
  csrfToken,
  team,
  currentUser,
  confirm,
  performer,
  deletePerformer,
  updatePerformer,
  provided,
  snapshot
}) => (
  <div className="row" ref={provided.innerRef} {...draggablePropsWithStyle(provided, snapshot)}>
    <div className="col-12">
      <div className="mb-2 p-2"
           style={{
             "background": "var(--sl-bg-secondary)",
             "borderRadius": "var(--sl-radius-md)"
           }}>
        <div className="row flex-column flex-md-row">
          <div className="col-xs-auto d-none d-md-flex align-items-center"
               style={{"paddingLeft": "15px"}}>
            <span {...provided.dragHandleProps}
                  aria-label="Drag to reorder"
                  className="d-flex"
                  style={{"marginLeft": "8px", "color": "var(--sl-text-quaternary)"}}>
              <DotsGrid width={16} height={16} />
            </span>
          </div>
          <div className="col-12 col-md d-flex flex-column flex-md-row align-items-center"
               style={{"paddingLeft": "12px"}}>
            {performer.artistable ? (
              <React.Fragment>
                <img src={performer.artistable.image_thumb_url_for_json}
                     className="img-fluid rounded-circle mb-2 mb-md-0 mr-md-3"
                     style={{"height": "60px", "width": "60px"}} />
                <strong title={performer.artistable.name} className="text-center text-md-left">
                  <a target="_blank"
                     style={{"fontSize": "20px", "color": "var(--sl-text-primary)"}}
                     href={"/artists/" + performer.artistable.permalink}>
                    {performer.artistable.name}
                  </a>
                </strong>
              </React.Fragment>
            ) : (
              <strong className="text-center text-md-left"
                      style={{"fontSize": "20px", "color": "var(--sl-text-tertiary)"}}>
                Artist unavailable
              </strong>
            )}
          </div>
          <div className="col-12 col-md-auto d-flex align-items-center justify-content-center justify-content-md-end mt-2 mt-md-0"
               style={{"paddingRight": "30px"}}>
            <Menu placement="bottom-end"
                  minWidth={140}
                  trigger={
                    <Button variant="link-color" trailingIcon={ChevronDown} className="mr-5">
                      {performer.humanized_act_type}
                    </Button>
                  }
                  items={[
                    {
                      label: "Headliner",
                      disabled: performer.act_type === "headline",
                      onClick: () => updatePerformer(csrfToken, team, {...performer, act_type: "headline"})
                    },
                    {
                      label: "Support",
                      disabled: performer.act_type === "support",
                      onClick: () => updatePerformer(csrfToken, team, {...performer, act_type: "support"})
                    }
                  ]} />
            <Menu placement="bottom-end"
                  minWidth={160}
                  trigger={
                    <Button variant="tertiary" size="sm" icon={DotsVertical} aria-label="Performer actions" />
                  }
                  items={[
                    {
                      label: "Remove",
                      icon: Trash01,
                      destructive: true,
                      onClick: () => deletePerformer(csrfToken, team, performer)
                    }
                  ]} />
          </div>
        </div>
      </div>
    </div>
  </div>
);

PerformerCard.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  confirm: PropTypes.object.isRequired,
  performer: PropTypes.object.isRequired,
  deletePerformer: PropTypes.func.isRequired,
  updatePerformer: PropTypes.func.isRequired,
  provided: PropTypes.object.isRequired,
  snapshot: PropTypes.object.isRequired
};

export default PerformerCard;
